var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIllVideosXmas = function SvgIllVideosXmas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 128,
    viewBox: "0 0 375 128",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 1056,
    r: 1000,
    fill: "#3CC265"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10479_16102",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 128
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 128,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10479_16102)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10479_16102",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -156,
    y: -12,
    width: 697,
    height: 136
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.77 55.7354C22.379 55.7354 -100.805 99.4005 -153.303 120.486L-156 -12H541L537.493 124C463.743 95.1835 340.816 55.7354 192.77 55.7354Z",
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10479_16102)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.948 66.3126C315.452 64.0025 316.26 60.1736 316.428 59.9084L310.836 57.5772L307.293 59.0084C307.19 60.2028 306.059 63.9692 305.805 64.3427L315.948 66.3126Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M293.801 54.9002C291.801 52.9063 295.348 50.1932 297.178 49.3477C296.572 49.2185 295.663 48.5119 296.884 46.7194C298.106 44.9269 302.094 42.9825 303.936 42.2344C303.291 42.208 301.969 41.8631 301.838 40.6949C301.407 37.9045 307.345 35.6434 308.872 34.7333C306.662 34.8328 306.871 31.4089 309.39 30.0923C312.049 28.7017 312.98 27.7685 314.8 26.8257C316.62 25.8829 316.49 26.0453 317.271 27.732C318.052 29.4188 320.28 30.7958 321.938 32.3844C324.06 35.4588 321.513 36.0789 319.974 36.0046C320.803 36.7989 324.074 38.8168 325.584 41.1429C327.016 43.3482 324.546 44.6595 323.327 44.7958C324.026 45.7525 325.782 46.8866 327.783 48.8805C329.592 52.3446 325.986 51.792 323.9 51.2369C325.688 52.6631 330.797 57.2889 329.967 59.1331C328.733 61.8732 325.866 59.9862 324.587 58.7002C325.175 63.9568 318.217 61.3348 317.338 58.772C314.87 63.1878 310.984 60.2221 310.885 58.0155C307.133 62.8706 304.4 58.2975 304.756 56.1878C300.306 61.4168 296.337 56.3906 298.189 54.4092C296.971 55.4326 295.202 56.2966 293.801 54.9002Z",
    fill: "#32BF5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.726 34.75C309.474 34.8142 311.187 34.7703 312.058 34.0815C312.2 35.347 312.977 37.8226 315.554 37.5343C317.163 37.3543 317.942 35.493 317.438 34.5145C317.931 34.9521 319.158 35.8596 320.121 35.9885M303.497 42.2837C304.25 42.3966 306.059 42.4111 307.268 41.5662C306.538 44.3091 309.674 48.5118 313.688 42.0306C314.485 43.8634 316.442 47.2571 318.518 46.8127C319.964 46.503 320.304 44.2473 319.881 43.1119C320.445 43.7387 321.94 44.8331 323.474 44.7797",
    stroke: "black",
    strokeWidth: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297.179 49.3477C298.159 49.2873 300.338 48.9943 301.209 48.3054C301.015 50.5448 303.877 53.625 307.305 49.8411C307.095 51.9344 308.92 55.0124 312.636 51.1665C312.768 53.6652 316.393 55.6251 318.163 51.5831C319.611 53.9345 323.2 55.5731 323.9 51.2369",
    stroke: "black",
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.646 26.4355C314.463 27.514 313.961 27.7081 313.858 27.6704L314.8 25.4952L312.508 24.8646L314.393 24.5058C313.975 23.8626 313.196 22.5404 313.417 22.3973C313.637 22.2543 314.831 23.5697 315.4 24.2452C315.617 23.5311 316.082 22.1287 316.212 22.2325C316.342 22.3362 316.43 23.7358 316.457 24.4227C317.362 24.1244 319.174 23.5569 319.187 23.6737C319.2 23.7905 317.904 24.5565 317.254 24.9249C317.996 25.384 319.455 26.3345 319.351 26.4644C319.13 26.6074 317.655 26.3092 316.946 26.1422C316.691 26.9591 316.151 28.5671 316.021 28.4634C315.89 28.3596 315.716 27.0682 315.646 26.4355Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.195,
    cy: 50.5457,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 318.195 50.5457)",
    fill: "#ED1B98"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.195,
    cy: 50.5457,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 318.195 50.5457)",
    fill: "#ED1B98"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 321.348,
    cy: 49.6014,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 321.348 49.6014)",
    fill: "#ED1B98"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 321.348,
    cy: 49.6014,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 321.348 49.6014)",
    fill: "#ED1B98"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.459,
    cy: 47.2947,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 323.459 47.2947)",
    fill: "#ED1B98"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 323.459,
    cy: 47.2947,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 323.459 47.2947)",
    fill: "#ED1B98"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.781,
    cy: 38.2449,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 319.781 38.2449)",
    fill: "#ED1B98"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.781,
    cy: 38.2449,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 319.781 38.2449)",
    fill: "#ED1B98"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.076,
    cy: 39.5467,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 316.076 39.5467)",
    fill: "#ED1B98"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.076,
    cy: 39.5467,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 316.076 39.5467)",
    fill: "#ED1B98"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.948,
    cy: 39.7127,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 311.948 39.7127)",
    fill: "#ED1B98"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.948,
    cy: 39.7127,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 311.948 39.7127)",
    fill: "#ED1B98"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.793,
    cy: 37.9959,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 308.793 37.9959)",
    fill: "#ED1B98"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.793,
    cy: 37.9959,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 308.793 37.9959)",
    fill: "#ED1B98"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.64,
    cy: 36.2791,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 305.64 36.2791)",
    fill: "#ED1B98"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.64,
    cy: 36.2791,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 305.64 36.2791)",
    fill: "#ED1B98"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.195,
    cy: 50.5457,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 318.195 50.5457)",
    fill: "#ED1B98"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.195,
    cy: 50.5457,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 318.195 50.5457)",
    fill: "#ED1B98"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 318.425,
    cy: 55.2518,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 318.425 55.2518)",
    fill: "#F6D703"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.16,
    cy: 55.842,
    rx: 0.809498,
    ry: 0.808105,
    transform: "rotate(-6.38394 311.16 55.842)",
    fill: "#ED1B98"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.161,
    cy: 54.5158,
    rx: 0.809498,
    ry: 0.808105,
    transform: "rotate(-6.38394 307.161 54.5158)",
    fill: "#ED1B98"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.961,
    cy: 55.6887,
    rx: 0.809498,
    ry: 0.808105,
    transform: "rotate(-6.38394 301.961 55.6887)",
    fill: "#ED1B98"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 298.058,
    cy: 52.5773,
    rx: 0.809498,
    ry: 0.808105,
    transform: "rotate(-6.38394 298.058 52.5773)",
    fill: "#ED1B98"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.749,
    cy: 56.8377,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 322.749 56.8377)",
    fill: "#F6D703"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 326.91,
    cy: 56.9637,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 326.91 56.9637)",
    fill: "#F6D703"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.808,
    cy: 44.3953,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 301.808 44.3953)",
    fill: "#ED1B98"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.808,
    cy: 44.3953,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 301.808 44.3953)",
    fill: "#ED1B98"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.808,
    cy: 44.3953,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 301.808 44.3953)",
    fill: "#ED1B98"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.808,
    cy: 44.3953,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 301.808 44.3953)",
    fill: "#ED1B98"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.808,
    cy: 44.3953,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 301.808 44.3953)",
    fill: "#F6D703"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.808,
    cy: 44.3953,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 301.808 44.3953)",
    fill: "#F6D703"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.808,
    cy: 44.3953,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 301.808 44.3953)",
    fill: "#F6D703"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.808,
    cy: 44.3953,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 301.808 44.3953)",
    fill: "#F6D703"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.808,
    cy: 44.3953,
    rx: 0.735907,
    ry: 0.73464,
    transform: "rotate(-6.38394 301.808 44.3953)",
    fill: "#F6D703"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.111,
    cy: 31.593,
    rx: 0.809498,
    ry: 0.808105,
    transform: "rotate(-6.38394 319.111 31.593)",
    fill: "#F6D703"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.722,
    cy: 32.0842,
    rx: 0.809498,
    ry: 0.808105,
    transform: "rotate(-6.38394 314.722 32.0842)",
    fill: "#F6D703"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.38,
    cy: 45.9084,
    rx: 0.809498,
    ry: 0.808105,
    transform: "rotate(-6.38394 315.38 45.9084)",
    fill: "#F6D703"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 312.911,
    cy: 47.6613,
    rx: 0.809498,
    ry: 0.808105,
    transform: "rotate(-6.38394 312.911 47.6613)",
    fill: "#F6D703"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 309.141,
    cy: 48.3801,
    rx: 0.809498,
    ry: 0.808105,
    transform: "rotate(-6.38394 309.141 48.3801)",
    fill: "#F6D703"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.849,
    cy: 47.0861,
    rx: 0.809498,
    ry: 0.808105,
    transform: "rotate(-6.38394 304.849 47.0861)",
    fill: "#F6D703"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M312.243 29.1399C312.414 29.4165 312.317 29.8018 311.801 29.9935C311.418 30.1703 310.987 30.1423 310.844 29.8327C310.667 29.4503 310.902 29.156 311.285 28.979C311.645 28.8123 311.933 28.7726 312.243 29.1399Z",
    fill: "#F6D703"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M323.05 38.2039C322.946 38.512 322.586 38.6831 322.11 38.4089C321.729 38.2271 321.476 37.8774 321.624 37.5697C321.806 37.1896 322.183 37.1831 322.564 37.3647C322.922 37.5354 323.136 37.7315 323.05 38.2039Z",
    fill: "#ED1B98"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M323.05 38.2039C322.946 38.512 322.586 38.6831 322.11 38.4089C321.729 38.2271 321.476 37.8774 321.624 37.5697C321.806 37.1896 322.183 37.1831 322.564 37.3647C322.922 37.5354 323.136 37.7315 323.05 38.2039Z",
    fill: "#ED1B98"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M319.113 30.0354C318.961 30.2747 318.621 30.345 318.275 30.0141C317.991 29.7814 317.849 29.4329 318.038 29.203C318.271 28.919 318.592 28.9917 318.876 29.2243C319.144 29.443 319.285 29.6534 319.113 30.0354Z",
    fill: "#F6D703"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M303.781 43.5396C303.781 43.5396 303.345 43.2505 302.456 43.2677C301.567 43.285 300.445 43.4317 300.445 42.5426C300.445 41.6534 300.717 40.7469 300.773 40.0434C300.829 39.3398 300.717 37.4147 301.498 37.3629C302.279 37.3111 302.478 37.76 302.62 38.4851C302.62 38.4851 303.108 37.2377 303.794 37.3499C304.481 37.4621 304.42 37.7082 304.558 38.7398C304.666 39.0851 304.576 39.2664 305.301 39.465C306.026 39.6635 308.037 40.0822 309.432 41.8951C309.993 42.8015 309.975 45.6633 307.748 46.2806C305.521 46.8978 304.886 46.0993 304.848 45.3396C304.822 44.7914 304.973 44.4375 305.214 44.2432C305.305 44.1698 305.409 44.118 305.521 44.0878C305.918 43.9799 306.302 43.8504 306.302 43.8504C306.302 43.8504 304.943 43.9756 303.781 43.544L303.781 43.5396Z",
    fill: "#F6D703"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10479_16102",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 300,
    y: 37,
    width: 10,
    height: 10
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M303.781 43.5396C303.781 43.5396 303.345 43.2505 302.456 43.2677C301.567 43.285 300.445 43.4317 300.445 42.5426C300.445 41.6534 300.717 40.7469 300.773 40.0434C300.829 39.3398 300.717 37.4147 301.498 37.3629C302.279 37.3111 302.478 37.76 302.62 38.4851C302.62 38.4851 303.108 37.2377 303.794 37.3499C304.481 37.4621 304.42 37.7082 304.558 38.7398C304.666 39.0851 304.576 39.2664 305.301 39.465C306.026 39.6635 308.037 40.0822 309.432 41.8951C309.993 42.8015 309.975 45.6633 307.748 46.2806C305.521 46.8978 304.886 46.0993 304.848 45.3396C304.822 44.7914 304.973 44.4375 305.214 44.2432C305.305 44.1698 305.409 44.118 305.521 44.0878C305.918 43.9799 306.302 43.8504 306.302 43.8504C306.302 43.8504 304.943 43.9756 303.781 43.544L303.781 43.5396Z",
    fill: "#F6D703"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10479_16102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.92 42.5383C308.064 42.5383 308.991 41.6107 308.991 40.4664C308.991 39.3221 308.064 38.3945 306.92 38.3945C305.775 38.3945 304.848 39.3221 304.848 40.4664C304.848 41.6107 305.775 42.5383 306.92 42.5383Z",
    fill: "url(#paint0_radial_10479_16102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.797 43.7219C300.941 43.7219 301.869 42.7943 301.869 41.65C301.869 40.5057 300.941 39.5781 299.797 39.5781C298.653 39.5781 297.725 40.5057 297.725 41.65C297.725 42.7943 298.653 43.7219 299.797 43.7219Z",
    fill: "url(#paint1_radial_10479_16102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.346 48.1408C307.49 48.1408 308.418 47.2132 308.418 46.0689C308.418 44.9247 307.49 43.9971 306.346 43.9971C305.202 43.9971 304.274 44.9247 304.274 46.0689C304.274 47.2132 305.202 48.1408 306.346 48.1408Z",
    fill: "url(#paint2_radial_10479_16102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.553 44.9852C310.449 44.9852 311.176 44.2586 311.176 43.3622C311.176 42.4659 310.449 41.7393 309.553 41.7393C308.656 41.7393 307.93 42.4659 307.93 43.3622C307.93 44.2586 308.656 44.9852 309.553 44.9852Z",
    fill: "url(#paint3_radial_10479_16102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.989 44.9852C304.885 44.9852 305.612 44.2586 305.612 43.3622C305.612 42.4659 304.885 41.7393 303.989 41.7393C303.092 41.7393 302.366 42.4659 302.366 43.3622C302.366 44.2586 303.092 44.9852 303.989 44.9852Z",
    fill: "url(#paint4_radial_10479_16102)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.989 39.326C304.885 39.326 305.612 38.5994 305.612 37.7031C305.612 36.8067 304.885 36.0801 303.989 36.0801C303.092 36.0801 302.366 36.8067 302.366 37.7031C302.366 38.5994 303.092 39.326 303.989 39.326Z",
    fill: "url(#paint5_radial_10479_16102)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M303.311 40.1482C303.628 40.1482 303.885 39.8911 303.885 39.5741C303.885 39.257 303.628 39 303.311 39C302.994 39 302.737 39.257 302.737 39.5741C302.737 39.8911 302.994 40.1482 303.311 40.1482Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M303.178 40.0661C303.421 40.0661 303.618 39.869 303.618 39.6258C303.618 39.3827 303.421 39.1855 303.178 39.1855C302.934 39.1855 302.737 39.3827 302.737 39.6258C302.737 39.869 302.934 40.0661 303.178 40.0661Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M302.124 40.2207C302.124 40.2207 302.331 40.7344 302.814 40.2552",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M301.835 40.0144C302.152 40.0144 302.409 39.7573 302.409 39.4403C302.409 39.1232 302.152 38.8662 301.835 38.8662C301.518 38.8662 301.261 39.1232 301.261 39.4403C301.261 39.7573 301.518 40.0144 301.835 40.0144Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M301.701 39.9333C301.944 39.9333 302.141 39.7362 302.141 39.493C302.141 39.2499 301.944 39.0527 301.701 39.0527C301.458 39.0527 301.261 39.2499 301.261 39.493C301.261 39.7362 301.458 39.9333 301.701 39.9333Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M304.467 38.0069C304.368 37.2731 303.798 37.3508 303.798 37.3508C303.53 37.3484 302.926 37.5817 302.654 38.5335C302.672 38.4751 302.654 37.3437 301.635 37.3437C300.615 37.3437 300.955 39.0434 300.785 39.8933",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5605 45.1551V43.6016L68.9113 42L70.5157 43.5754V45.1551",
    fill: "#ED1B98"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9116 42H74.3235L75.8754 43.5492L70.516 43.5754L68.9116 42Z",
    fill: "#0066FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.875 43.5488H70.5156V45.2944H75.875V43.5488Z",
    fill: "#FCAEE0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7408 47.4648L54 56.0662H57.6196L64.0588 49.6381L60.7408 47.4648Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8577 55.634V65.4005H69.9116V53.2949L84.8577 55.634Z",
    fill: "#FCAEE0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7109 54.2148L71.5513 56.4012H84.7706V65.98",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1987 65.3998V53.1808L62.4936 45.2559L69.8508 53.9314V64.8761L56.1987 65.3998Z",
    fill: "#ED1B98"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7548 53.9365H56.4175V65.405H69.7548V53.9365Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7548 53.9365L56.4175 65.405",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7548 65.405L56.4175 53.9365",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4717 45.26L62.5766 45.1553L71.6998 55.9604L87 56.004V56.2004L71.678 56.231L62.4717 45.26Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7107 45.1426L62.5767 45.1557L71.6999 55.9608L87 56.0044L77.7107 45.1426Z",
    fill: "#0066FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2881 47.8721L62.9375 49.624L64.6924 50.2722L62.9375 50.9205L62.2881 52.6724L61.6387 50.9205L59.8838 50.2722L61.6387 49.624L62.2881 47.8721Z",
    fill: "#F6D703"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5063 45.0361C64.6192 46.9272 69.3258 49.7928 71.2493 45.2543C72.8522 46.9272 76.6262 49.3564 78.8994 46.5635",
    stroke: "black",
    strokeWidth: 0.25
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1567 55.0732C70.3753 56.0915 71.2059 57.6916 72.7796 57.6916C74.3533 57.6916 75.1839 56.8188 75.4025 56.1642C75.6939 56.8916 76.4954 57.6916 78.0254 57.6916C79.3368 57.6916 80.5025 56.6006 80.4297 56.1642C80.794 56.8188 81.4692 57.4734 83.0526 57.4734C84.5826 57.4734 85.1654 56.6734 85.2383 56.1642",
    stroke: "black",
    strokeWidth: 0.25
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.2474,
    cy: 47.9355,
    rx: 0.500862,
    ry: 0.5,
    fill: "#F6D703"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.2533,
    cy: 47.9355,
    rx: 0.500862,
    ry: 0.5,
    fill: "#F6D703"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.75,
    cy: 57.5362,
    rx: 0.5,
    ry: 0.499139,
    fill: "#F6D703"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.9951,
    cy: 57.755,
    rx: 0.5,
    ry: 0.499139,
    fill: "#F6D703"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.2421,
    cy: 57.5371,
    rx: 0.500862,
    ry: 0.5,
    fill: "#F6D703"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.8096,
    cy: 57.5362,
    rx: 0.5,
    ry: 0.499139,
    fill: "#ED0080"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.6182,
    cy: 57.5362,
    rx: 0.5,
    ry: 0.499139,
    fill: "#ED0080"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.8638,
    cy: 57.3175,
    rx: 0.5,
    ry: 0.499139,
    fill: "#ED0080"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M330.701 63.3931C330.162 63.2732 330.056 63.5618 329.942 63.8008C329.514 64.6972 328.968 66.2063 328.795 67.324C328.727 67.7701 328.952 67.765 329.127 67.8126C330.591 68.3545 333.81 69.434 334.02 69.4912C334.231 69.5484 334.353 69.3492 334.387 69.2424C334.607 68.9867 335.887 65.7654 336.023 65.3875C336.16 65.0096 335.744 64.9408 335.807 64.9634C333.915 64.2833 331.375 63.543 330.701 63.3931Z",
    fill: "#2FCDF2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M333.197 63.806C333.468 63.0994 334.274 61.7282 335.332 61.8962C335.743 61.9746 336.469 62.3812 336.089 63.3803C335.876 63.9423 334.863 64.7534 333.554 64.3844C333.535 64.3779 333.514 64.3705 333.49 64.3622C333.368 65.3689 332.515 67.7655 332.096 68.8683L330.871 68.4855C331.325 67.5735 331.951 65.0974 332.224 63.8694C331.609 63.5983 330.492 62.959 331.085 62.1695C331.686 61.37 332.609 61.8864 332.807 62.0731C333.047 62.2995 333.492 62.6078 333.197 63.806Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M333.73 63.8024C333.989 63.3416 334.712 62.4591 335.224 62.8971C335.426 63.0693 335.041 63.6275 333.73 63.8024Z",
    fill: "#F6D703"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M332.71 63.4588C332.609 63.0993 332.297 62.4402 331.86 62.6797C331.422 62.9193 332.244 63.299 332.71 63.4588Z",
    fill: "#F6D703"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M289.012 61.1162C289.012 61.1162 314.659 64.0147 328.562 66.2872",
    stroke: "black",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7926 77.0088C17.7926 77.0088 14.907 75.6512 14.9637 73.511C15.0204 71.3708 17.8493 73.057 18.307 75.0804C18.307 75.0804 18.0019 71.9458 19.9808 69.9267C21.9597 67.9075 22.8097 69.3559 22.6877 70.5579C22.5656 71.7599 22.7182 74.0557 20.1334 76.2867L17.7926 77.0088Z",
    fill: "#3CC265"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M136.9 58.3013C136.9 58.3013 135.661 57.3329 135.981 56.2044C136.3 55.0759 137.136 55.4448 137.22 56.6086C137.22 56.6086 137.986 54.4086 139.392 54.9376C140.797 55.4665 138.117 58.3935 137.753 58.3718C137.389 58.3501 136.903 58.304 136.903 58.304L136.9 58.3013Z",
    fill: "#32BF5E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M344.678 71.4907C344.678 71.4907 342.724 70.3373 343.033 67.4668C343.342 64.5964 344.575 65.3328 344.851 66.0316C345.127 66.7304 345.602 68.4512 345.429 68.8908C345.337 69.1237 345.62 69.3229 345.745 68.9396C345.87 68.2596 345.37 66.9784 345.469 66.3848C345.568 65.7912 346.533 61.8011 347.901 62.0077C349.27 62.2144 347.386 68.098 346.599 68.8344C346.599 68.8344 348.45 66.9108 349.443 67.6434C350.437 68.3761 348.107 71.4945 346.393 71.4945H344.678V71.4907Z",
    fill: "#3CC265"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1311 80.2338C72.1311 80.2338 79.0151 77.5839 84.3363 81.8877C84.3363 81.8877 89.4468 77.0299 97.6075 80.4266C97.6075 80.4266 102.325 76.2774 110.372 77.3977C110.372 77.3977 104.553 74.917 98.2624 77.5577C98.2624 77.5577 90.1741 73.4827 83.4482 78.8989C83.4482 78.8989 78.9259 77.2939 72.1276 80.2339L72.1311 80.2338Z",
    fill: "#F6D703"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M322.398 95.8408C322.398 95.8408 329.212 94.6996 333.292 99.647C333.292 99.647 338.895 96.1465 345.748 100.793C345.748 100.793 350.857 97.868 358.033 100.409C358.033 100.409 353.156 97.0393 346.886 98.2848C346.886 98.2848 340.226 93.0268 333.039 96.7383C333.039 96.7383 329.19 94.4163 322.398 95.8408Z",
    fill: "#F6D703"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M274.846 75.1782C274.846 75.1782 282.799 74.3223 287.284 80.1345C287.284 80.1345 293.946 76.5532 301.662 82.202C301.662 82.202 307.724 79.2374 315.916 82.5356C315.916 82.5356 310.429 78.4479 303.104 79.4536C303.104 79.4536 295.641 73.1329 287.13 76.8505C287.13 76.8505 282.781 74.0028 274.842 75.1773L274.846 75.1782Z",
    fill: "#F6D703"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8902 70.8285C82.8936 71.1269 82.985 71.699 83.0182 72.1964C83.1428 74.0618 83.6394 77.042 84.3885 79.0361C84.6875 79.832 85.0529 79.6164 85.3851 79.5335C88.2917 79.0776 94.5785 77.892 94.9771 77.7925C95.3757 77.6931 95.3923 77.2537 95.3508 77.0464C95.4754 76.4246 94.6034 69.958 94.4788 69.2118C94.3542 68.4657 93.6068 68.7352 93.7314 68.7144C89.9942 69.3362 85.1359 70.4554 83.8902 70.8285Z",
    fill: "#0066FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3748 69.2116C88.1671 67.8022 88.2253 64.8094 90.1188 64.113C90.8662 63.8642 92.4358 63.8642 92.7348 65.854C92.903 66.9732 91.9874 69.2365 89.4959 69.8334C89.4585 69.8402 89.4165 69.8477 89.3701 69.8558C90.0994 71.6212 90.9105 76.3418 91.2399 78.5384L88.8731 79.0358C88.7771 77.1206 87.5193 72.4783 86.8327 70.2111C85.5725 70.3305 83.1459 70.3075 83.3919 68.4655C83.641 66.6001 85.6342 66.6001 86.1325 66.7244C86.7367 66.8753 87.7519 66.9732 88.3748 69.2116Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2468 68.7134C89.2468 67.7185 89.6205 65.6045 90.8662 65.8532C91.3563 65.951 91.24 67.2211 89.2468 68.7134Z",
    fill: "#32BF5E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2537 69.0865C86.7554 68.589 85.6342 67.7932 85.1359 68.589C84.6376 69.3849 86.3401 69.2523 87.2537 69.0865Z",
    fill: "#32BF5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10479_16102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.92 40.4664) scale(2.07187 2.07188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#EC1E98",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EC1E98",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#EC1E98",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#EC1E98",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EC1E98",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10479_16102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(299.797 41.65) scale(2.07187 2.07188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EC1E98",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EC1E98",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#EC1E98",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#EC1E98",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#EC1E98",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EC1E98",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#EC1E98",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_10479_16102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.346 46.0689) scale(2.07187 2.07187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#EC1E98",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#EC1E98",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EC1E98",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EC1E98",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EC1E98",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EC1E98",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC1E98",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC1E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_10479_16102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(309.553 43.3622) scale(1.62296 1.62297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#32CDF1",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#32CDF1",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#32CDF1",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF0",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#32CDF0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_10479_16102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.989 43.3622) scale(1.62296 1.62297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#32CDF1",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#32CDF1",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#32CDF1",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#32CDF1",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#32CDF1",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#32CDF0",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_10479_16102",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(303.989 37.703) scale(1.62296 1.62297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32CDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#32CDF1",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#32CDF1",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#32CDF1",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#32CDF1",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#32CDF1",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32CDF0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#32CDF0",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32CDF0",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllVideosXmas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ill_videos_xmas.2a85cbc3.svg";
export { ForwardRef as ReactComponent };